export const EMPTY_PREFERENCES = { hidden: [], widths: {}, order: [] };

const isApplicable = column => true !== column.hidden;

// `customizable: false` keeps a column out of the picker — neither hideable nor
// reorderable — but still resizable, since the handle is in the header.
const isCustomizable = column => isApplicable(column) && false !== column.customizable;

export const customizableColumns = columns => columns.filter(isCustomizable);

export const orderedColumns = (columns, order) => {
  if (!order?.length) { return columns; }

  const byKey = new Map(columns.map(column => [column.key, column]));
  const ordered = order.map(key => byKey.get(key)).filter(Boolean);
  const placed = new Set(ordered.map(column => column.key));

  return [...ordered, ...columns.filter(column => !placed.has(column.key))];
};

export const applyPreferences = (columns, preferences) => {
  const { hidden = [], widths = {} } = preferences || {};
  const hiddenKeys = new Set(hidden);

  return orderedColumns(columns, preferences?.order).map(column => {
    const updated = { ...column };

    if (isCustomizable(column) && hiddenKeys.has(column.key)) {
      updated.hidden = true;
    }

    if (isApplicable(column) && undefined !== widths[column.key]) {
      updated.width = widths[column.key];
    }

    return updated;
  });
};

export const toggleHidden = (preferences, key) => {
  const hidden = preferences.hidden || [];

  return {
    ...preferences,
    hidden: hidden.includes(key) ?
      hidden.filter(hiddenKey => hiddenKey !== key) :
      [...hidden, key],
  };
};

export const setWidth = (preferences, key, width) => ({
  ...preferences,
  widths: { ...preferences.widths, [key]: width },
});

// Indices are positions within the customizable subset, which is what the
// picker lists. Columns outside it keep their absolute position.
export const reorder = (preferences, columns, fromIndex, toIndex) => {
  const movableKeys = customizableColumns(columns).map(column => column.key);
  const [moved] = movableKeys.splice(fromIndex, 1);

  movableKeys.splice(toIndex, 0, moved);

  let nextMovable = 0;
  const order = columns.map(column => (
    isCustomizable(column) ? movableKeys[nextMovable++] : column.key
  ));

  return { ...preferences, order };
};
